/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Text_Opacity_Aria_LabelInputs */

const en_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Opacity`)
};

const fr_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite du texte`)
};

const de_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textdeckkraft`)
};

const it_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità del testo`)
};

const ru_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачность текста`)
};

const es_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad del texto`)
};

const zh_cn2_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本不透明度`)
};

const ja_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの不透明度`)
};

const hi_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ अपारदर्शिता`)
};

const pt_pt2_styles_text_opacity_aria_label = /** @type {(inputs: Styles_Text_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade do texto`)
};

/**
* | output |
* | --- |
* | "Text Opacity" |
*
* @param {Styles_Text_Opacity_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_text_opacity_aria_label = /** @type {((inputs?: Styles_Text_Opacity_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Text_Opacity_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_text_opacity_aria_label(inputs)
	if (locale === "de") return de_styles_text_opacity_aria_label(inputs)
	if (locale === "it") return it_styles_text_opacity_aria_label(inputs)
	if (locale === "ru") return ru_styles_text_opacity_aria_label(inputs)
	if (locale === "es") return es_styles_text_opacity_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_text_opacity_aria_label(inputs)
	if (locale === "ja") return ja_styles_text_opacity_aria_label(inputs)
	if (locale === "hi") return hi_styles_text_opacity_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_text_opacity_aria_label(inputs)
	return en_styles_text_opacity_aria_label(inputs)
});